document.querySelectorAll('.external-video-slide').forEach(($externalVideoSlide) => {
  const $externalVideo = $externalVideoSlide.querySelector('.external-video');
  const $content = $externalVideoSlide.querySelector('.external-video-slide__content');

  $externalVideo?.addEventListener('external-video:visible', () => {
    $content?.remove();
  });
});
